export default __webpack_public_path__ + "static/solar-1c59dc23d62691fbbabf9c3b634b8547.jpg";